/*
CopyRight: 2019 - ArTiBulles
Created on : 02-July-2019
Author: Arnaud Jaspard - Arnaud.jaspard@artibulles.com
Version: 1.0
Description: Creating React Icons with Frames
License : MIT
*/
import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
var name = 'Facebook';
var keywords = ['Search'];
var category = 'navigation';
var meta = {
  keywords: keywords,
  name: name,
  category: category,
  "class": "Icon_".concat(name)
};
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Facebook"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(2.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M96,48.0338443 C96,21.5054651 74.5096875,0 48,0 C21.4903125,0 0,21.5054651 0,48.0338443 C0,72.0089244 17.5529062,91.8806759 40.5,95.483871 L40.5,61.9186274 L28.3125,61.9186274 L28.3125,48.0338443 L40.5,48.0338443 L40.5,37.451388 C40.5,25.4129057 47.6660625,18.7632204 58.6303125,18.7632204 C63.8819062,18.7632204 69.375,19.7013814 69.375,19.7013814 L69.375,31.5222103 L63.3223125,31.5222103 C57.3595313,31.5222103 55.5,35.2248504 55.5,39.0234644 L55.5,48.0338443 L68.8125,48.0338443 L66.684375,61.9186274 L55.5,61.9186274 L55.5,95.483871 C78.4470937,91.8806759 96,72.0089244 96,48.0338443",
  id: "Fill-1",
  fill: "#1877F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66.4895566,61.8001879 L68.6027397,47.8947698 L55.3837089,47.8947698 L55.3837089,38.8709991 C55.3837089,35.0667397 57.2301841,31.3585969 63.1510997,31.3585969 L69.1612903,31.3585969 L69.1612903,19.5202004 C69.1612903,19.5202004 63.7067645,18.5806452 58.492043,18.5806452 C47.6048679,18.5806452 40.4890264,25.240213 40.4890264,37.2965863 L40.4890264,47.8947698 L28.3870968,47.8947698 L28.3870968,61.8001879 L40.4890264,61.8001879 L40.4890264,95.4153148 C42.9157425,95.7996868 45.4027821,96 47.9363677,96 C50.4699532,96 52.9570859,95.7996868 55.3837089,95.4153148 L55.3837089,61.8001879 L66.4895566,61.8001879 Z",
  id: "Fill-3",
  fill: "#FFFFFF"
}))))), meta);